import React from "react";
import { MdOutlineEmail, MdOutlineLocationOn, MdOutlinePhone } from "react-icons/md";

const contactItems = [
  {
    title: "Chat to Sales",
    desc: "Speak to our friendly team.",
    links: [
      { label: "Send an Email", href: "mailto:weavinghandindia@gmail.com" }
    ],
    icon: <MdOutlineEmail className="text-[1.5rem]" />
  },
  {
    title: "Visit Us",
    desc: "No: 144, Barracka Street, Chennai.",
    links: [
      { label: "View on Google Maps →", href: "https://g.co/kgs/vven78K" }
    ],
    icon: <MdOutlineLocationOn className="text-[1.5rem]" />
  },
  {
    title: "Call Us",
    desc: "Mon–Sun from 8am to 9pm.",
    links: [
      { label: "+91 94441 61667", href: "tel:9444161667" },
      { label: "+91 93607 05042", href: "tel:9360705042" }
    ],
    icon: <MdOutlinePhone className="text-[1.5rem]" />
  }
];

// ─── Shared reusable cards grid ─────────────────────────────────────────────
export const ContactCards = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
    {contactItems.map((item, idx) => (
      <div
        key={idx}
        className="group flex flex-row md:flex-col items-center md:items-start gap-4 md:gap-5 p-5 md:p-8 border border-charcoal/10 hover:border-brass/40 hover:shadow-md bg-white/60 hover:bg-white transition-all duration-300 rounded-lg"
      >
        <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-linen border border-brass/30 text-brass group-hover:bg-brass group-hover:text-linen transition-colors duration-300">
          {item.icon}
        </div>
        <div className="text-left w-full">
          <h3 className="font-serif text-charcoal text-lg md:text-xl mb-1">{item.title}</h3>
          <p className="text-charcoal/50 text-sm mb-2 md:mb-3">{item.desc}</p>
          <div className="flex flex-col gap-2">
            {item.links.map((link, lIdx) => (
              <a 
                key={lIdx}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-brass text-sm font-medium tracking-wide hover:underline decoration-brass/30 underline-offset-4"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

// ─── Standalone /contact route page ─────────────────────────────────────────
export const Contact = () => (
  <div className="bg-linen pt-28 md:pt-36 pb-14 md:pb-20 px-6">
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-10 md:mb-14">
        <span className="text-brass uppercase tracking-[0.2em] text-xs font-semibold block mb-3">Get In Touch</span>
        <h1 className="text-4xl md:text-6xl font-serif text-charcoal mb-3">Contact Our Team</h1>
        <p className="text-charcoal/60 font-sans text-sm md:text-base">Let us know how we can help.</p>
      </div>
      <ContactCards />
    </div>
  </div>
);

